module.exports = __webpack_public_path__ + "static/washer-d92759647ee4f02f27265f8fd1d7301c.png";